import { Controller } from "@hotwired/stimulus"

const INACTIVE_CLASSES = ["c-button--white-inactive"]

export default class extends Controller {
  static values = { url: String, current: String }
  static targets = ["button"]

  select(event) {
    const theme = event.currentTarget.dataset.theme
    if (theme === this.currentValue) return

    this.currentValue = theme
    this.updateButtons()
    this.applyThemeClass(theme)
    this.persist(theme)
  }

  updateButtons() {
    for (const button of this.buttonTargets) {
      const isActive = button.dataset.theme === this.currentValue
      button.classList.toggle(...INACTIVE_CLASSES, !isActive)
    }
  }

  applyThemeClass(theme) {
    document.documentElement.classList.remove("dark", "system")
    if (theme === "dark" || theme === "system") {
      document.documentElement.classList.add(theme)
    }
  }

  async persist(theme) {
    await fetch(this.urlValue, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0]?.content,
      },
      body: JSON.stringify({ user: { theme_preference: theme } }),
    })
  }
}
